/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// derived from WebSpecter (https://github.com/jgonera/webspecter) MIT license
import { extendLeft } from "./utils";
import OverStore from "../../../app/data/OverStore";

/*
    Spin until 'conditionFn' returns true, then execute 'fn'.  If it takes more
    than the 'for' key of the 'options' object's value (1000ms by default) give
    up.  If a 'timeoutFn' is provided, it will be invoked and passed the
    augmented 'options' object (including an __error key), otherwise an error
    will be raised.
*/
const _until = function (conditionFn, options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    extendLeft(options, {
            "for": 1000,
            message: conditionFn.message || conditionFn.toString(),
        },
    );
    if (options.__timed_out) {
        return;
    }
    if (conditionFn()) {
        clearTimeout(options.timeoutId);
        fn();
    } else {
        if (!options.timeoutId) {
            // eslint-disable-next-line no-settimeout
            options.timeoutId = setTimeout((function () {
                options.__timed_out = true;
                options.__error = new Error(`Timeout waiting until: ${options.message}`);
                if (timeoutFn != null) {
                    return timeoutFn(options);
                } else {
                    throw options.__error;
                }
            }), options.for);
        }
        // eslint-disable-next-line no-settimeout
        setTimeout((function () {
            _until(conditionFn, options, fn, timeoutFn);
        }), 250);
    }
};

/*
    Spin while 'conditionFn' returns true, then execute 'fn'. The exact inverse
    of 'until', with all the same options and semantics.
*/
const _while = function(conditionFn, options, fn, timeoutFn) {
    const negatedConditionFn = () => !conditionFn();
    _until(negatedConditionFn, options, fn, timeoutFn);
};

let ajaxCount = 0;
let ajaxRunning = false;
let ajaxDelayCount = 0;
let ajaxDelayed = false;
$(document)
.ajaxStart(() => ajaxRunning = true)
.ajaxSend(() => ajaxCount++)
.ajaxComplete(function() {
    if (ajaxCount > 0) {
        return ajaxCount--;
    } else {
        return console.log("IT> {ajax completed, but count was already zero...}");
    }
})
.ajaxStop(function() {
    if (!ajaxRunning) {
        console.log("IT> {ajax stop, but not running...}");
    }
    return ajaxRunning = false;
})
.on("ajaxDelay", function() {
    ajaxDelayCount++;
    return ajaxDelayed = true;
})
.on("ajaxResume", function() {
    if (!ajaxDelayed) {
        console.log("IT> {ajax resume, but not delayed...}");
    }
    if (ajaxDelayCount > 0) {
        ajaxDelayCount--;
    } else {
        console.log("IT> {ajax resumed, but count was already zero...}");
    }
    return ajaxDelayed = ajaxDelayCount > 0;
});

/*
    Spin until all in-flight Ajax calls are complete, then execute 'fn'.
    Equivalent to "while( -> [[ajax in flight]], options, fn)".
*/
export function ajax(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    extendLeft(options,
        {message: "wait.ajax (ajax is done)"});
    const conditionFn = () => ajaxRunning || ajaxDelayed || (window.hotLoadObjectActiveCount > 0);
    _while(conditionFn, options, fn, timeoutFn);
}


const isOverShowing = () => OverStore.isModalShowing();

/*
    Spin until all overs have closed, then execute 'fn'.  Equivalent to
    "while ( -> [[over visible]], options, fn)".
*/
export function over(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    extendLeft(options,
        {message: "wait.over (overs are closed)"});
    const conditionFn = () => isOverShowing();
    _while(conditionFn, options, fn, timeoutFn);
}

let viewStackCount = 0;
let viewStackPending = false;
Backbone.dispatcher.on("viewstack:next", function() {
    viewStackCount++;
    return viewStackPending = true;
}).on("viewstack:ready", function() {
    if (viewStackCount > 0) {
        viewStackCount--;
    } else {
        console.log("IT> {viewstack ready, but count was already zero...}");
    }
    if (!viewStackPending) {
        console.log("IT> {viewstack:ready, but nothing pending...}");
    }
    return viewStackPending = viewStackCount > 0;
});
/*
    Spin until all pending viewstack operations have concluded, then execute
    'fn'.  Equivalent to "while ( -> [[viewstack pending]], options, fn)".
*/
export function viewstack(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    extendLeft(options,
        {message: "wait.viewstack (viewstack is ready)"});
    const conditionFn = () => viewStackPending;
    _while(conditionFn, options, fn, timeoutFn);
}

/*
    Spin until all Ajax calls are complete and overs are hidden, then
    execute 'fn'.  This is a combination of 'over' and 'ajax'.
*/
export function sync(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    extendLeft(options,
        {message: "wait.sync (ajax, over, and viewstack)"});
    const conditionFn = () => ajaxRunning || ajaxDelayed || isOverShowing() || viewStackPending || (window.hotLoadObjectActiveCount > 0);
    _while(conditionFn, options, fn, timeoutFn);
}

/*
    Spin until the current call stack is complete, then execute 'fn'.  If a
    specific delay is desired, it may be passed as the 'for' key in the options
    (expressed in milliseconds).
*/
export function tick(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    if (options.delay != null) {
        throw new Error("The 'delay' option is obsolete; use 'for' instead.");
    }
    extendLeft(options,
        {for: 0});
    // all the _while machinery is irrelevant, short circuit
    // eslint-disable-next-line no-settimeout
    setTimeout(fn, options.for, timeoutFn);
}

export default {
    "while": _while,
    "until": _until,
    ajax,
    over,
    viewstack,
    sync,
    tick,
};



// WEBPACK FOOTER //
// ./test/it/lib/wait.js